const DEVICE_ID_KEY = "wu.deviceId";

/** Generates a UUID, falling back when crypto.randomUUID is unavailable. */
function makeId(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  return `dev-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

/**
 * Returns a stable per-device id, generating and persisting one in
 * localStorage on first visit. This is a best-effort UX identity (e.g.
 * one vote per device in DJ requests), NOT a security control. Falls
 * back to an ephemeral id when localStorage is unavailable.
 */
export function getDeviceId(): string {
  try {
    const existing = window.localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;
    const id = makeId();
    window.localStorage.setItem(DEVICE_ID_KEY, id);
    return id;
  } catch {
    return makeId();
  }
}
